import { AlertTriangle, Bell, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn, timeAgo } from "@/lib/utils";
import type { Notification } from "@/lib/api";

export function NotificationDetailDialog({
  notification,
  onOpenChange,
  onMarkRead,
}: {
  notification: Notification | null;
  onOpenChange: (open: boolean) => void;
  onMarkRead: (id: string) => void;
}) {
  const Icon =
    notification?.severity === "critical"
      ? AlertTriangle
      : notification?.severity === "warning"
        ? Bell
        : Info;

  return (
    <Dialog open={notification !== null} onOpenChange={onOpenChange}>
      <DialogContent>
        {notification ? (
          <>
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <span
                  className={cn(
                    "flex h-8 w-8 shrink-0 items-center justify-center rounded-full",
                    notification.severity === "critical" && "bg-destructive/10 text-destructive",
                    notification.severity === "warning" && "bg-warning/15 text-warning-foreground",
                    notification.severity === "info" && "bg-info/10 text-info"
                  )}
                >
                  <Icon className="h-4 w-4" />
                </span>
                <span className="truncate">{notification.title}</span>
              </DialogTitle>
              <DialogDescription>{timeAgo(notification.created_at)}</DialogDescription>
            </DialogHeader>
            <p className="text-sm text-foreground">{notification.detail}</p>
            <DialogFooter>
              {notification.read_at === null ? (
                <Button
                  size="sm"
                  onClick={() => {
                    onMarkRead(notification.id);
                  }}
                >
                  Mark as read
                </Button>
              ) : null}
            </DialogFooter>
          </>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
